export type ErrorKind = "AUTH" | "TRANSIENT" | "PERMANENT";

export class ApiRequestError extends Error {
  constructor(
    message: string,
    public readonly kind: ErrorKind,
    public readonly status?: number,
    public readonly serverMessage?: string,
  ) {
    super(message);
    this.name = "ApiRequestError";
  }
}

export class AuthError extends ApiRequestError {
  constructor(message: string, status?: number, serverMessage?: string) {
    super(message, "AUTH", status, serverMessage);
    this.name = "AuthError";
  }
}

export class TransientError extends ApiRequestError {
  constructor(message: string, status?: number, serverMessage?: string) {
    super(message, "TRANSIENT", status, serverMessage);
    this.name = "TransientError";
  }
}
